

export const Duration = (value: number) => {
    return String(Math.floor(value/60)).padStart(2, "0") + ":" + String(value % 60).padStart(2, "0");
}